/*
 * Inline Report Story button used by the LEGACY (Bootstrap-style) more-menu
 * branch in `part-actions.hbs` and `share-tools.hbs`. Honors
 * `IS_NEW_REPORT_STORY_PART_FLOW` to switch between the legacy modal and the
 * new webview popup.
 *
 * This component is NOT used when `IS_REACT_PART_FOOTER_ACTIONS` is on — the
 * React ActionMenu replacement (`PartActionsMore.js`) renders its own report
 * item that mirrors this component: it also switches between the webview popup
 * and the legacy modal based on `IS_NEW_REPORT_STORY_PART_FLOW`. Both paths
 * converge on the same `/webview/report/storypart/{partId}` route once
 * `IS_NEW_REPORT_STORY_PART_FLOW` hits 100% and Phase 1 cleanup retires both
 * this component and the legacy-modal branch in `PartActionsMore.js`.
 */

import React from "react";
import { useReportModal, useTrans } from "../hooks";
import { openResponsivePopup } from "../helpers";
import Icon from "./Icon";
import PropTypes from "prop-types";

const ReportStoryPart = ({ partId, storyId, storyTitle, author, language }) => {
  const { trans } = useTrans();
  const { openReportStoryModal } = useReportModal();

  const handleOnClick = () => {
    if (wattpad?.testGroups?.IS_NEW_REPORT_STORY_PART_FLOW) {
      openResponsivePopup({
        url: `/webview/report/storypart/${partId}`,
        width: 500,
        height: 700
      });
      return;
    }
    openReportStoryModal(storyId, storyTitle, author, language, partId);
  };

  return (
    <button className="btn-option" onClick={handleOnClick}>
      <Icon
        iconName="fa-warning"
        color="wp-neutral-2"
        height="20"
        className="pull-left"
      />
      {trans("Report Story")}
    </button>
  );
};

ReportStoryPart.propTypes = {
  partId: PropTypes.string.isRequired,
  storyId: PropTypes.string, // Marking as optional since it's not used in the new flow, but still needed for the old flow
  storyTitle: PropTypes.string,
  author: PropTypes.string,
  language: PropTypes.string
};

export default ReportStoryPart;
